import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';
import '../styles/admin-scroll-to-top.css';

export default function AdminScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const contentDiv = document.querySelector('.admin-layout__content');
      const contentScroll = contentDiv ? contentDiv.scrollTop : 0;
      const windowScroll = window.scrollY || document.documentElement.scrollTop || 0;
      
      // Show button if either the window or the container has scrolled down past 300px
      if (contentScroll > 300 || windowScroll > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    const contentDiv = document.querySelector('.admin-layout__content');
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    if (contentDiv) {
      contentDiv.addEventListener('scroll', handleScroll, { passive: true });
    }

    // Trigger once on mount
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (contentDiv) {
        contentDiv.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  const scrollToTop = () => {
    const contentDiv = document.querySelector('.admin-layout__content');
    
    if (contentDiv && contentDiv.scrollTop > 0) {
      contentDiv.scrollTo({ top: 0, behavior: 'smooth' });
    }
    
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      type="button"
      className={`admin-scroll-to-top-btn ${isVisible ? 'is-visible' : ''}`}
      onClick={scrollToTop}
      aria-label="Scroll to top"
    >
      <ArrowUp size={24} />
    </button>
  );
}
